var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "fundos-investimento" },
    [
      _c(
        "v-row",
        { staticClass: "flex-column", attrs: { align: "start" } },
        [
          _c(
            "v-row",
            { staticClass: "d-flex flex-wrap flexx" },
            [
              _c(
                "div",
                { staticClass: "bloco" },
                [
                  _c(
                    "v-col",
                    { staticClass: "d-flex flex-column align-left py-0" },
                    [
                      _c("span", { staticClass: "text-filelds" }, [
                        _vm._v(_vm._s(_vm.formLabel))
                      ])
                    ]
                  ),
                  _c(
                    "v-col",
                    [
                      _c("v-autocomplete", {
                        staticClass: "select",
                        attrs: {
                          loading: _vm.ativosFull.length == 0,
                          items: _vm.ativosFull,
                          disabled: _vm.loading,
                          "return-object": "",
                          "item-text": "code",
                          "menu-props": { bottom: true, offsetY: true },
                          placeholder: "Selecione Fundo",
                          color: "secondary",
                          required: "",
                          dense: "",
                          outlined: "",
                          rounded: "",
                          clearable: "",
                          attach: "",
                          filter: _vm.filterObject
                        },
                        on: { change: _vm.changeActive },
                        model: {
                          value: _vm.ativo,
                          callback: function($$v) {
                            _vm.ativo = $$v
                          },
                          expression: "ativo"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-row", { staticClass: "d-flex flex-wrap flexx" }, [
                _c(
                  "div",
                  { staticClass: "bloco" },
                  [
                    _c(
                      "v-col",
                      { staticClass: "d-flex flex-column align-left py-0" },
                      [
                        _c("span", { staticClass: "text-filelds" }, [
                          _vm._v("Custodiante")
                        ])
                      ]
                    ),
                    _c(
                      "v-col",
                      [
                        _c("v-autocomplete", {
                          staticClass: "select",
                          attrs: {
                            items: _vm.custodians,
                            disabled: _vm.loading,
                            loading: _vm.loading,
                            "item-text": "fullName",
                            "item-value": "entityId",
                            placeholder: "Insira o custodiante",
                            color: "secondary",
                            required: "",
                            outlined: "",
                            dense: "",
                            rounded: "",
                            height: "10",
                            clearable: "",
                            attach: "",
                            filter: _vm.filterObject,
                            rules: [
                              function(v) {
                                return v != null || "Campo obrigatório"
                              }
                            ]
                          },
                          on: { change: _vm.saveCustodiante },
                          model: {
                            value: _vm.custodiante,
                            callback: function($$v) {
                              _vm.custodiante = $$v
                            },
                            expression: "custodiante"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "bloco" },
                [
                  _c(
                    "v-col",
                    { staticClass: "d-flex flex-column align-left py-0" },
                    [
                      _c("span", { staticClass: "text-filelds" }, [
                        _vm._v("Gestor")
                      ])
                    ]
                  ),
                  _c("v-col", { staticClass: "column" }, [
                    _c("span", { staticClass: "btn" }, [
                      _vm._v(" " + _vm._s(_vm.gestor ? _vm.gestor : "") + " ")
                    ])
                  ])
                ],
                1
              )
            ],
            1
          ),
          _c("v-row", { staticClass: "d-flex flex-wrap flexx" }, [
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Estratégia")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.estrategia ? _vm.estrategia : "Automático") +
                        " "
                    )
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Indice referência")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(
                      " " + _vm._s(_vm.indice ? _vm.indice : "Automático") + " "
                    )
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Forma de Tributação")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(_vm._s(_vm.formaTributacao) + " ")
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Classe ANBIMA")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(" " + _vm._s(_vm.classeAmbima) + " ")
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Formas de Gestão")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(" " + _vm._s(_vm.formasGestao) + " ")
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [_c("span", { staticClass: "text-filelds" }, [_vm._v("FGC")])]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(" " + _vm._s(_vm.FGCDesc) + " ")
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Cota Aplicação (D +)")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(" " + _vm._s(_vm.cotaAplicacao) + " ")
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Cota Resgate (D +)")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(" " + _vm._s(_vm.cotaResgate) + " ")
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Crédito do resgate (D +)")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(" " + _vm._s(_vm.creditoResgate) + " ")
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Data Investimento")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "py-0 flex-grow-0 flex-shrink-1",
                    staticStyle: { padding: "0" }
                  },
                  [
                    _c("DatePiker", {
                      on: { change: _vm.saveDataInvestimento }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Valor da Cota na data")
                    ])
                  ]
                ),
                _c("v-col", { staticClass: "column", attrs: { cols: "1" } }, [
                  _c("span", { staticClass: "btn" }, [
                    _vm._v(
                      _vm._s(_vm.currencyHelper.formatValue(_vm.vPrecoUnitario))
                    )
                  ])
                ])
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Nº de Cotas")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", staticStyle: { padding: "0" } },
                  [
                    _c("ValorMonetario", {
                      attrs: { value: _vm.vQtd },
                      on: { change: _vm.saveShareQuantity }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "bloco" },
              [
                _c(
                  "v-col",
                  { staticClass: "d-flex flex-column align-left py-0" },
                  [
                    _c("span", { staticClass: "text-filelds" }, [
                      _vm._v("Total Investido(R$)")
                    ])
                  ]
                ),
                _c(
                  "v-col",
                  { staticClass: "py-0", staticStyle: { padding: "0" } },
                  [
                    _c("ValorMonetario", {
                      attrs: { value: _vm.vPrecoUnitarioQtd },
                      on: { change: _vm.saveInvestedValue }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }